import {
  Autocomplete,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  TextField
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const OverwriteAndSendNewVersionDialog: FC<any> = ({
  openOverwriteAndNewversion,
  setOpenOverwriteAndNewversion,
  setIsSentToIsf,
  taskId
}: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = React.useState(false);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const [checked, setChecked] = useState<boolean>(false);
  const [radVal, setRadVal] = useState<string>('');
  const dispatch = useDispatch();

  const handleCloseDialog = () => {
    setOpenOverwriteAndNewversion(false);
  };

  const handleConfirmClick = async () => {
    const Data = {
      action_name: 'Sent To ISF',
      sent_to_isf: true,
      is_resolved: false,
      updated_by: userName
    };
    setProcessing(true);
    const response = await docService.sendToISF(
      documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
      Data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      'Site',
      'DocumentApproval',
      documentDetail.data[0].tmf_document_name,
      radVal === 'overwrite' ? true : false,
      false
    );
    if (response?.data) {
      setProcessing(false);
      setOpenOverwriteAndNewversion(false);
      setIsSentToIsf(true);
      store.dispatch(setSnackbarMessage('Document sent to ISF successfully.', 'success'));
      setDocumentDetail(dispatch, [{ ...documentDetail.data[0], sent_to_isf: true }]);
    } else {
      setProcessing(false);
      setOpenOverwriteAndNewversion(false);
      store.dispatch(setSnackbarMessage('Error in Sending To ISF.', 'error'));
    }
  };
  const handleRadioValue = (e: any, value: any) => {
    setChecked(true);
    setRadVal(value);
  };

  return (
    <React.Fragment>
      <PopupComponent open={openOverwriteAndNewversion}>
        <DialogTitle>Send to ISF</DialogTitle>
        <DialogContent className="sendToDialog">
          {isProcessing && (
            <Box sx={{ width: '100%' }} mb={2}>
              <LinearProgress />
            </Box>
          )}
          <DialogContentText>
            The current document already exists in ISF. Please select one of the options below to proceed.
          </DialogContentText>
          <Paper sx={{ width: '100%', maxHeight: 242, bgcolor: 'background.paper', overflowY: 'auto' }}>
            <List dense={true}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemText primary={documentDetail.data[0].tmf_document_name} />
                </ListItemButton>
              </ListItem>
            </List>
          </Paper>
          <FormControl>
            <RadioGroup
              aria-labelledby="sent to ISF choice"
              defaultValue=""
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              <FormControlLabel value="newVersion" control={<Radio />} label="Send the document as new version" />
              <FormControlLabel value="overwrite" control={<Radio />} label="Overwrite the document" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} className="grey-btn" disabled={isProcessing}>
            Cancel
          </Button>
          <Button onClick={handleConfirmClick} disabled={!checked || isProcessing}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(OverwriteAndSendNewVersionDialog);
